import React, { Component } from 'react';
import VideoPlayer from '../../components/VideoPlayer';
import axios from 'axios';
import { urlMap } from '../../../utils';

// import the modal + editor we built earlier
import Modal from '../../components/Modal';
import VideoPinEditor from './videoEditor/PinEditor';

class ChunksPanel extends Component {
  state = {
    decoratedUrls: {},    // store decorated video URLs per chunk
    modalOpen: false,     // modal visibility
    selectedUrl: null     // which chunk URL is being decorated
  };

  handleDecorate = (url) => {
    // Instead of immediately calling backend,
    // open the modal and let user place pins
    this.setState({ modalOpen: true, selectedUrl: url });
  };

  closeModal = () => {
    this.setState({ modalOpen: false, selectedUrl: null });
  };

  // These two will connect VideoPinEditor -> backend
  requestImageForTimestamp = async (timeSec) => {
    // call your backend: send timestamp + selected chunk url
    const res = await axios.post(
      urlMap.decorateChunk, 
      { url: this.state.selectedUrl, timeSec },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
      }
    );
    // backend should return { id, status?, imageUrl? }
    return res.data;
  };

  refreshPins = async (pins) => {
    if (!pins.length) return pins;
    const ids = pins.map((p) => p.id).join(',');
    const res = await axios.get(
      `${urlMap.decorateChunk}/status?ids=${encodeURIComponent(ids)}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
      }
    );
    const { items } = res.data; // [{ id, status, imageUrl?, error? }]
    const map = new Map(items.map((i) => [i.id, i]));
    return pins.map((p) => (map.get(p.id) ? { ...p, ...map.get(p.id) } : p));
  };

  render() {
    const { chunks, handleVideoError } = this.props;
    const { decoratedUrls, modalOpen, selectedUrl } = this.state;

    return (
      <div className="chunks-panel">
        <div className="chunks-rail">
          {chunks.map((u, i) => (
            <div className="chunk-card" key={u}>
              <div className="chunk-media">
                <VideoPlayer
                  src={decoratedUrls[u] || u}
                  onLoadedMetadata={undefined}
                  onError={handleVideoError}
                  labelKey={`chunk:${i + 1}`}
                />
                <span className="chunk-label">Chunk {i + 1}</span>
              </div>

              <div className="chunk-actions">
                
                
                <button
                  className="decorate-btn"
                  onClick={() => this.handleDecorate(u)}
                  title="Decorate this chunk"
                >
                  ✨ Decorate
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Modal integration */}
        <Modal isOpen={modalOpen} onClose={this.closeModal}>
          {selectedUrl && (
            <VideoPinEditor
              src={decoratedUrls[selectedUrl] || selectedUrl}
              maxDurationSec={25}
              requestImageForTimestamp={this.requestImageForTimestamp}
              refreshPins={this.refreshPins}
            />
          )}
        </Modal>
      </div>
    );
  }
}

export default ChunksPanel;
